import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class EmailConfirmationService {
  private readonly httpClient = inject(HttpClient);

  confirmEmail(userEmailConfirmationToken: string): Observable<void> {
    const url = `api/v2/users/user/email-confirmation/${userEmailConfirmationToken}`;

    return this.httpClient.put<void>(environment.portalApiUrl + url, null);
  }
}
